import { Injectable, signal } from '@angular/core';

export interface CupomRecente {
  codigo: string;
  nrSequencia: number;
}

const STORAGE_KEY = 'simcarecupons.recentes';
const MAX_ITENS = 5;

@Injectable({ providedIn: 'root' })
export class CuponsRecentesService {
  private readonly _lista = signal<CupomRecente[]>(this.load());

  readonly lista = this._lista.asReadonly();

  registrar(codigo: string, nrSequencia: number): void {
    if (!codigo) return;
    const atual = this._lista();
    const semDuplicata = atual.filter(c => c.codigo !== codigo);
    const nova = [{ codigo, nrSequencia }, ...semDuplicata].slice(0, MAX_ITENS);
    this._lista.set(nova);
    this.save(nova);
  }

  limpar(): void {
    this._lista.set([]);
    this.save([]);
  }

  private load(): CupomRecente[] {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed.filter(c => c && typeof c.codigo === 'string' && typeof c.nrSequencia === 'number');
    } catch {
      return [];
    }
  }

  private save(lista: CupomRecente[]): void {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(lista));
    } catch {
      // ignora — localStorage pode estar bloqueado
    }
  }
}
